export default "__VITE_PUBLIC_ASSET__8ea0ccd3__"